import { OfbizForm, OfbizList } from "@urbannex/ofbiz-forms";
import { ConfigOptions, getAppContext, getColumnFieldTitles, getFields, getIdFieldName, getTarget, getTargets, getTitleDescriptionField } from "@urbannex/view-containers";
import { CAT_FORMS } from "./forms";

export const categoryOptions:ConfigOptions = {
    name:"",
    title:"Categories Component",
    menuAndTitleOptions:{
        path:"categories",
        headerTitle:"Category Information",
        menuItems:[],
        menuTag:"categoriesMenu"
    },
    listForm:new OfbizList( { 
      listType:"grid",
      listFormName:"EditProdCatalogCategories",
      listFormLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
      columnFields:getFields("EditProdCatalogCategories",CAT_FORMS),
      columnFieldTitles:getColumnFieldTitles("EditProdCatalogCategories",CAT_FORMS),
      fieldFormFields:getFields("AddProductCategoryToProdCatalog",CAT_FORMS),
      appContext:"product",
      emptyListMessage:"No categories found. Please add category",
      remoteFormData:{
        formData:{
          formName:"EditProdCatalogCategories",
          formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
          listType:"grid",

        },
        parameters:{"prodCatalogId":"DemoCatalog"}
      },
    }),
    addForm:new OfbizForm({
      local:true,
        formName:"EditCategory",
        formLocation:"component://kwikstore/widget/CategoryForms.xml",
        fields:getFields("EditCategory",CAT_FORMS),
        titleDescriptionField:getTitleDescriptionField("EditCategory",CAT_FORMS),
      idFieldName:getIdFieldName("EditCategory",CAT_FORMS),
    }),
    findForm:new OfbizForm(),
    actions:["list","find","add","edit"],
    settings:[],
    breadCrumbData:{
      displayPrefix:"Product Catalog Categories",
      label:"",
      level:1,
      selectedValue:{
        "event":"list",
        "type":"EditProdCatalogCategories",
        "data":{
          formData:{
            formName:"EditProdCatalogCategories",
            formLocation:"component://product/widget/catalog/ProdCatalogForms.xml",
            listType:"grid"
          },
          "endPoint":"",
          "parameters":{"prodCatalogId":""}
        }
      },
      addFormText:"Create Category",
      editFormText:"Update Category"
    },
    relations:[
      {
        title:"Content",
        addContainerTitle:"Add Content",
        listContainerTitle:"Content for this Category",
        keyMap:{fieldName:"productCategoryId"},
        addFormName:"AddCategoryContentAssoc",
        listFormName:"UpdateCategoryContentAssoc",
        listForm:new OfbizList({
          listFormName:"UpdateCategoryContentAssoc",
          listFormLocation:"component://product/widget/catalog/CategoryForms.xml",
          target:getTarget("UpdateCategoryContentAssoc",CAT_FORMS),
          columnFields:getFields("UpdateCategoryContentAssoc",CAT_FORMS),
          fieldFormFields:getFields("UpdateCategoryContentAssoc",CAT_FORMS),
          columnFieldTitles:getColumnFieldTitles("UpdateCategoryContentAssoc",CAT_FORMS),
          appContext:getAppContext("UpdateCategoryContentAssoc",CAT_FORMS),
          emptyListMessage:"No content found for this category. Please add existing content or create new content to add.",
          remoteFormData:{
            formData:{
              formName:"UpdateCategoryContentAssoc",
              formLocation:"component://product/widget/catalog/CategoryForms.xml",
              listType:"grid"
            }
          }
        }),
        addForm:new OfbizForm({
          formName:"AddCategoryContentAssoc",
          local:true,
          appContext:getAppContext("AddCategoryContentAssoc",CAT_FORMS),
          targets:getTargets("AddCategoryContentAssoc",CAT_FORMS),
          formLocation:"component://product/widget/catalog/CategoryForms.xml",
          fields:getFields("AddCategoryContentAssoc",CAT_FORMS)
        })
          
      },
      {
        title:"Products",
        addContainerTitle:"Add Product to Category",
        listContainerTitle:"Products In This Category",
        keyMap:{fieldName:"productCategoryId"},
        addFormName:"AddProductCategoryMember",
        listFormName:"EditCategoryProducts",
        listForm:new OfbizList({
          listType:"grid",
          listFormName:"EditCategoryProducts",
          listFormLocation:"component://kwikstore/widget/KwikstoreForms.xml",
          target:getTarget("EditCategoryProducts",CAT_FORMS),
          columnFields:getFields("EditCategoryProducts",CAT_FORMS),
          fieldFormFields:getFields("EditCategoryProducts",CAT_FORMS),
          columnFieldTitles:getColumnFieldTitles("EditCategoryProducts",CAT_FORMS),
          appContext:getAppContext("EditCategoryProducts",CAT_FORMS),
          emptyListMessage : "No products found.  Please add products",
          remoteFormData:{
            formData:{
              formName:"EditCategoryProducts",
              formLocation:"component://kwikstore/widget/KwikstoreForms.xml",
              listType:"grid"
            }
          }
        }),
        addForm:new OfbizForm({
          formName:"AddProductCategoryMember",
          local:true,
          appContext:getAppContext("AddProductCategoryMember",CAT_FORMS),
          targets:getTargets("AddProductCategoryMember",CAT_FORMS),
          formLocation:"component://kwikstore/widget/KwikstoreForms.xml",
          fields:getFields("AddProductCategoryMember",CAT_FORMS)
        })
      },
      {
        title:"Parties",
        addContainerTitle:"Add Team Member To Category",
        listContainerTitle:"Category Team",
        keyMap:{fieldName:"productCategoryId"},
        addFormName:"AddPartyToCategory",
        listFormName:"ListCategoryParties",
        addForm:new OfbizForm({
          local:true,
          formName:"AddPartyToCategory",
          formLocation:"component://kwikstore/widget/CategoryForms.xml",
          fields:getFields("AddPartyToCategory",CAT_FORMS),
          idFieldName:getIdFieldName("AddPartyToCategory",CAT_FORMS),
          titleDescriptionField:getTitleDescriptionField("AddPartyToCategory",CAT_FORMS),
          targets:getTargets("AddPartyToCategory",CAT_FORMS),
          appContext:"product",
        }),
        listForm:new OfbizList({
          listType:"form",
          listFormName:"ListCategoryParties",
          listFormLocation:"component://kwikstore/widget/CategoryForms.xml",
          columnFields:getFields("ListCategoryParties",CAT_FORMS),
          columnFieldTitles:getColumnFieldTitles("ListCategoryParties",CAT_FORMS),
          appContext:"product",
          emptyListMessage: "No people associated with this category.  Please add existing person/organisation and create a new person or organisation.",
          remoteFormData: {
            formData: {
              formName: "ListCategoryParties",
              formLocation: "component://kwikstore/widget/CategoryForms.xml",
              listType: "form"
            }
          }
        })
      },
      {
        title:"Parent Categories",
        addContainerTitle:"",
        listContainerTitle:"",
        keyMap:{fieldName:""},
        addFormName:"AddProductCategoryToCategory",
        listFormName:"EditCategoryParentCategories",
        addForm:new OfbizForm({
          local:true,
          formName:"AddProductCategoryToCategory",
          formLocation:"component://kwikstore/widget/CategoryForms.xml",
          fields:getFields("AddProductCategoryToCategory",CAT_FORMS),
          idFieldName:"productCategoryId",
          titleDescriptionField:"categoryName",
          targets:getTargets("AddProductCategoryToCategory",CAT_FORMS),
          target:getTarget("AddProductCategoryToCategory",CAT_FORMS),
          appContext:"product",
        }),
        listForm:new OfbizList({
          listFormName:"EditCategoryParentCategories",
          listFormLocation:"component://kwikstore/widget/CategoryForms.xml",
          listType:"form",
          columnFields:getFields("EditCategoryParentCategories",CAT_FORMS),
          columnFieldTitles:getColumnFieldTitles("EditCategoryParentCategories",CAT_FORMS),
          remoteFormData:{
            formData: {
              formName: "EditCategoryParentCategories",
              formLocation: "component://kwikstore/widget/CategoryForms.xml",
              listType: "form",
              entityName: "",
              viewIndex: 0,
              viewSize: 20
            }
          },
          appContext:"product",
          emptyListMessage: "No parent category for this category.  Please add existing category as parent. This is not required."
        })

      },
      {
        title:"Child Categories",
        addContainerTitle:"Add Child Category",
        listContainerTitle:"Child Categories",
        keyMap:{fieldName:"productCategoryId"},
        addFormName:"AddChildCategoryToCategory",
        listFormName:"EditCategoryChildCategories",
        addForm:new OfbizForm({
          local:true,
          formName:"AddChildCategoryToCategory",
          formLocation:"component://kwikstore/widget/CategoryForms.xml",
          fields:getFields("AddChildCategoryToCategory",CAT_FORMS),
          idFieldName:"productCategoryId",
          titleDescriptionField:"categoryName",
          targets:getTargets("AddChildCategoryToCategory",CAT_FORMS),
          target:getTarget("AddChildCategoryToCategory",CAT_FORMS),
          appContext:"product",
        }),
        listForm:new OfbizList({
          listFormName:"EditCategoryChildCategories",
          listFormLocation:"component://kwikstore/widget/CategoryForms.xml",
          listType:"form",
          columnFields:getFields("EditCategoryChildCategories",CAT_FORMS),
          columnFieldTitles:getColumnFieldTitles("EditCategoryChildCategories",CAT_FORMS),
          remoteFormData:{
            formData: {
              formName: "EditCategoryChildCategories",
              formLocation: "component://kwikstore/widget/CategoryForms.xml",
              listType: "form",
              entityName: "",
              viewIndex: 0,
              viewSize: 20
            }
          },
          appContext:"product",
          emptyListMessage:"No child categories for this category. Please add existing category as child or create a new one.  This is not required."
        })
      },
      {
        title:"Product Feature Category Groups",
        addContainerTitle:"Add Product Feature Category Group",
        listContainerTitle:"Product Feature Category Groups",
        addFormName:"AddFeatureGroupToCategory",
        listFormName:"EditCategoryFeatureGroupFeature",
        keyMap:{"fieldName":"productCategoryId"},
        addForm:new OfbizForm({
          formName:"AddFeatureGroupToCategory",
          formLocation:"component://kwikstore/widget/CategoryForms.xml",
          fields:getFields("AddFeatureGroupToCategory",CAT_FORMS),
          targets:getTargets("AddFeatureGroupToCategory",CAT_FORMS),
          idFieldName:"productCategory",
          titleDescriptionField:"categoryName",
          appContext:"product"
        }),
        listForm:new OfbizList({
          listFormName:"EditCategoryFeatureGroupFeature",
          listFormLocation:"component://kwikstore/widget/CategoryForms.xml",
          columnFields:getFields("EditCategoryFeatureGroupFeature",CAT_FORMS),
          columnFieldTitles:getColumnFieldTitles("EditCategoryFeatureGroupFeature",CAT_FORMS),
          remoteFormData:{
            formData: {
              formName: "EditCategoryFeatureGroupFeature",
              formLocation: "component://kwikstore/widget/CategoryForms.xml",
              listType: "form",
              entityName: "",
              viewIndex: 0,
              viewSize: 20
            }
          },
          appContext:"product",
          listType:"form",
          emptyListMessage:"No Product Feature Category Groups for this category.  Please add exiting or create new."
        })
      },
      {
        title:"Product Feature Categories",
        addContainerTitle:"Add Product Feature Category",
        listContainerTitle:"Product Feature Categories",
        addFormName:"AddFeatureCategoryToCategory",
        listFormName:"EditCategoryFeatureCategoryFeature",
        keyMap:{"fieldName":"productCategoryId"},
        addForm:new OfbizForm({
          formName:"AddFeatureCategoryToCategory",
          formLocation:"component://kwikstore/widget/CategoryForms.xml",
          fields:getFields("AddFeatureCategoryToCategory",CAT_FORMS),
          appContext:"product",
          idFieldName:"productCategoryId",
          titleDescriptionField:"categoryName",
          targets:getTargets("AddFeatureCategoryToCategory",CAT_FORMS)
        }),
        listForm:new OfbizList({
          listFormName:"EditCategoryFeatureCategoryFeature",
          listFormLocation:"component://kwikstore/widget/CategoryForms.xml",
          columnFields:getFields("EditCategoryFeatureCategoryFeature",CAT_FORMS),
          columnFieldTitles:getColumnFieldTitles("EditCategoryFeatureCategoryFeature",CAT_FORMS),
          appContext:"product",
          listType:"form",
          emptyListMessage:"No product feature categories for this category. Please add exisiting or create new.",
          remoteFormData: {
            formData: {
              formName: "EditCategoryFeatureCategoryFeature",
              formLocation: "component://kwikstore/widget/CategoryForms.xml",
              listType: "form"
            }
          }
        })
      }
    ],
    outGoingLinks:[
      {
        target:"EditProductRest",
        targetType:"",
        targetWindow:"",
        root:"products",
        segments:[
          {pathElement:"products",parameter:"productCategoryId"},
          {pathElement:"product",parameter:"productId"}
        ],
        parameters:{},
        remoteFormData:{
          formData:{
            formName:"EditProductRest",
            formLocation:"component://kwikstore/widget/ProductForms.xml"
          }
        }
      }
    ]
  }